export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <span className="brand">
      <svg aria-hidden="true" viewBox="0 0 28 28">
        <path d="m14 2 12 6.6L14 15 2 8.6 14 2Z" fill="currentColor" />
        <path d="m2 11 10.5 5.8V26L2 20.2V11Zm24 0-10.5 5.8V26L26 20.2V11Z" opacity=".58" />
      </svg>
      {!compact && <span>Family Move Inventory</span>}
    </span>
  );
}
